export default __webpack_public_path__ + "static/media/avatar.0f583cc8.png";